<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">

    <div class="card my-4">
      <div class="card-header row m-0">
        <div class="col">
          <h4>Хэрэглэгчдийн мэдээлэл</h4>
        </div>
        

      </div>
      <div class="card-body">

        <div>
          <div >
            <div class="table-responsive">
              <table
                class="table table-bordered"
                id="dataTable"
                width="100%"
                cellspacing="0"
                v-if="stores!=null && stores.length>0"
              >
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Нэр</th>
                    <th>Утас</th>
                    <th>Хаяг</th>
                    <th>Сүүлд нэвтэрсэн</th>
                    <!-- <th>Үйлдэл</th> -->
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(store, index) in stores">
                    <td>{{index+1}}</td>
                    <td>{{store.name}}
                    </td>
                    <td class="text-primary">{{store.phone}}</td>
                    <td>
                      <div v-if="store.shortAddress">
                        <span v-if="store.shortAddress.city">{{store.shortAddress.city}}</span>
                        <span v-if="store.shortAddress.district"> - {{store.shortAddress.district}}</span>
                        <span v-if="store.shortAddress.horoo"> -  {{store.shortAddress.horoo}}</span>
                      </div>
                    </td>
                    <td>
                      <span class="text-danger font-weight-bold text-lg" v-if="store.lastLoginDate">{{store.lastLoginDate | formatDate}}.</span>
                    </td>
                    <!-- <td>
                      <div class="row">

                
                      </div>
                    </td> -->
                  </tr>
                </tbody>
              </table>
              <div v-else class="alert alert-info text-center">Мэдээлэл оруулаагүй байна.</div>
              <button v-if="end==false" class="btn btn-block btn-success" @click="getItems()">Дараагийнх</button>
            </div>
           

          </div>


        </div>
      </div>
    </div>


  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig.js";
import moment from "moment";
export default {
  name: "Users",
  data() {
    return {
      stores: [],
      end: false,
      lastVisible:null,
      firstVisible:null,
      loading:false,
      pageSize: 50,      
      selectedStore:null,
      chargeValue:0

    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  created() {
    this.getItems();
    // this.setLL();
  },
  methods: {
    setLL(){
      
      // fb.db.collection("users").get().then(docs=>{
      //   if(docs){
      //     for(const userDoc of docs.docs){
      //       if(userDoc && userDoc.exists){
      //         if(userDoc.data() && userDoc.data().last_login && userDoc.data().last_login.length>0){
      //           userDoc.ref.update({"lastLoginDate":userDoc.data().last_login[userDoc.data().last_login.length-1] });
      //         }
      //         else{
      //           userDoc.ref.update({"lastLoginDate": null});
      //         }
      //       }

      //     }
      //     console.log("DONE");
      //   }
      // });
    },
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
    },
    async getItems(){
      if(this.end!=true){
        var querySnapshot;
        var first=false;
        if(this.lastVisible==null){
          querySnapshot=await fb.db.collection("users").orderBy("lastLoginDate", "desc")
          .limit(this.pageSize)
          .get();
          if(querySnapshot!=null && !querySnapshot.empty){
            this.firstVisible=querySnapshot.docs[0];
            first=true;
          }
        }
        else{
          querySnapshot=await fb.db.collection("users").orderBy("lastLoginDate", "desc").startAfter(this.lastVisible)
          .limit(this.pageSize)
          .get();
        }
        
        if(querySnapshot!=null && !querySnapshot.empty){

          if(first==true || ( first!=null && this.firstVisible.id!=null && this.firstVisible.id!=querySnapshot.docs[0].id)){
            for(const itemDoc of querySnapshot.docs){
              let item=itemDoc.data();
              item.id=itemDoc.id;
              item.ll=item.lastLoginDate?item.lastLoginDate:null;
             
              if(item.balance==undefined)
                item.balance=0;
              this.stores.push(item);
              this.stores.sort(function(a, b) {
                if(a.ll && b.ll)
                  return b.ll-(a.ll)
                return null;
              });
            }
            this.lastVisible=querySnapshot.docs[querySnapshot.docs.length-1];
          }
          else
            this.end=true;
          
        }
      }
    },

   
  },
  filters: {
    formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).format('YYYY/MM/DD HH:mm');
    },
  }
};
</script>